<script setup lang="ts">

import { ref, watchEffect } from 'vue';

const props = defineProps<{
    src: string,
    href: string,
    title: string,
    alt: string,
    action: string,
    width: string,
    height: string,
}>();

const src1x = ref();
const src2x = ref();

watchEffect(() => {
    if (!props.action || !props.width || !props.height) {
        src1x.value = props.src;
        src2x.value = props.src;

        return;
    }

    const h1 = props.height;
    const w1 = props.width;
    const h2 = h1 == "X" ? "X" : h1 * 2;
    const w2 = w1 == "X" ? "X" : w1 * 2;

    src1x.value = props.src + "." + props.action + w1 + "x" + h1;
    src2x.value = props.src + "." + props.action + w2 + "x" + h2;
});

</script>

<template>
    <a :href="href" v-if="href && src != ''">
        <picture>
            <source type="image/webp" :srcset="src1x + '.webp 1x, ' + src2x + '.webp 2x'">
            <source type="image/jpeg" :srcset="src1x + '.jpg 1x, ' + src2x + '.jpg 2x'">
            <img 
                :src="src1x + '.jpg'"
                :title="props.title"
                :alt="props.alt"
            />
        </picture>
    </a>
    <picture v-else-if="src != ''">
        <source type="image/webp" :srcset="src1x + '.webp 1x, ' + src2x + '.webp 2x'">
        <source type="image/jpeg" :srcset="src1x + '.jpg 1x, ' + src2x + '.jpg 2x'">
        <img 
            :src="src1x + '.jpg'"
            :title="props.title"
            :alt="props.alt"
        />
    </picture>
</template>
